import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useModal } from '../../../../hooks/use-modal';
import { SplitShipModal } from '../../../../orders/split-ship';
import { ManagePresetsModal } from '../../../../components/modals/manage-presets-modal';
import { ChildrenPropType } from '../../../../prop-types/children';

const OtherActionsContext = createContext({});

export const useOtherActionsContext = () => useContext(OtherActionsContext);

const OtherActionsContextProvider = ({ children }) => {
  const [splitShipSalesOrderId, setSplitShipSalesOrderId] = useState('');

  const { close: closeManagePresetsModal, isOpen: isManagePresetsModalOpen, open: openManagePresetsModal } = useModal();

  const { isOpen: isSplitShipModalOpen, open: _openSplitShipModal, close: closeSplitShipModal } = useModal();

  const openSplitShipModal = useCallback(
    (salesOrderId) => {
      setSplitShipSalesOrderId(salesOrderId);
      _openSplitShipModal();
    },
    [_openSplitShipModal],
  );

  const value = useMemo(
    () => ({
      openManagePresetsModal,
      openSplitShipModal,
    }),
    [openManagePresetsModal, openSplitShipModal],
  );

  return (
    <OtherActionsContext.Provider value={value}>
      <>
        {children}
        {isManagePresetsModalOpen && <ManagePresetsModal onClose={closeManagePresetsModal} />}
        {isSplitShipModalOpen && <SplitShipModal onClose={closeSplitShipModal} salesOrderId={splitShipSalesOrderId} />}
      </>
    </OtherActionsContext.Provider>
  );
};

export default OtherActionsContextProvider;

OtherActionsContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};
